import Vue from "vue";
import VueMoment from "vue-moment";
import moment from "moment-timezone";

Vue.use(VueMoment, { moment });
